import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import logo from './image.png';
import './Header.css';

const Header = () => {
    const navigate = useNavigate();
    const [theme, setTheme] = useState(() => document.documentElement.dataset.theme || 'dark');

    useEffect(() => {
        const syncTheme = () => setTheme(document.documentElement.dataset.theme || 'dark');
        window.addEventListener('storage', syncTheme);
        window.addEventListener('message', syncTheme);
        return () => {
            window.removeEventListener('storage', syncTheme);
            window.removeEventListener('message', syncTheme);
        };
    }, []);

    // On utilise userId maintenant pour vérifier si on est logué
    const userId = localStorage.getItem("userId");
    const userName = localStorage.getItem("userName");

    // Si pas de userId, le header ne s'affiche pas (ex: sur la page Login)
    if (!userId) return null;

    const handleLogout = () => {
        // Pas besoin de fetch complexe ici vu qu'on gère tout par localStorage
        console.log("%c--- DÉCONNEXION @M SERVICES ---", "color: orange; font-weight: bold");

        localStorage.removeItem("userId");
        localStorage.removeItem("userName");
        navigate("/login");
    };

    const toggleTheme = () => {
        const nextTheme = theme === 'dark' ? 'light' : 'dark';
        document.documentElement.dataset.theme = nextTheme;
        document.documentElement.style.colorScheme = nextTheme;
        localStorage.setItem('ams_theme', nextTheme);
        setTheme(nextTheme);
    };

    return (
        <header className="main-header">
            <div className="header-left">
                <img src={logo} alt="@m Services" className="h-logo" />
            </div>

            <nav className="header-center">
                {/* Ici tu pourras rajouter tes futurs liens comme :
                <NavLink to="/admin" className="nav-link">Tableau de bord</NavLink> 
                */}
            </nav>

            <div className="header-right">
                <span className="user-welcome"><span>Connecté en tant que</span> <strong>{userName}</strong></span>
                <NavLink
                    to="/archives"
                    className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}
                >
                    Archives
                </NavLink>
                <button
                    type="button"
                    onClick={toggleTheme}
                    className="theme-toggle"
                    aria-label={theme === 'dark' ? 'Activer le mode clair' : 'Activer le mode sombre'}
                    title={theme === 'dark' ? 'Mode clair' : 'Mode sombre'}
                >
                    <span className="theme-toggle-track" aria-hidden="true">
                        <span className="theme-toggle-thumb">{theme === 'dark' ? '☾' : '☀'}</span>
                    </span>
                </button>
                <button onClick={handleLogout} className="btn-logout">
                    Déconnexion
                </button>
            </div>
        </header>
    );
};

export default Header;
